// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.taxcal {
  align-items: center;
  justify-content: center;
  display: flex;
}

.taxcal_main {
  padding: 32px;
  display: flex;
  width: 85%;
  gap: 32px;
  border-radius: 16px;
  border: 1px solid #9e54e3;
  justify-content: space-between;
}

.taxcal_left,
.taxcal_right {
  width: 49%;
  padding: 16px;
  gap: 8px;
}

.taxcal_right {
  border-radius: 16px;
  border: 1px solid #d8bcf6;
  background-color: #faf6fe;
}

.income-section h2,
.tax-section h2 {
  font-family: Sora;
  font-size: 24px;
  font-weight: 600;
  line-height: 32px;
  text-align: left;
  color: #0e121b;
}

.income-section p {
  font-family: Inter;
  font-size: 14px;
  font-weight: 400;
  line-height: 24px;
  text-align: left;
  color: #99a0ae;
}

.income-input {
  width: 100%;
  padding: 8px;
  color: #0e121b;
  margin-bottom: 10px;
  border: 1px solid #cacfd8;
  border-radius: 6px;
  font-family: Sora;
  font-size: 20px;
  font-weight: 400;
  line-height: 28px;
  letter-spacing: 0.15px;
  text-align: left;
}

.income-slider {
  -webkit-appearance: none;
  width: 100%;
  height: 8px;
  border-radius: 5px;
  background: #faf6fe;
  outline: none;
  opacity: 0.7;
  transition: opacity 0.2s;
  margin-bottom: 10px;
}

.income-slider::-webkit-slider-runnable-track {
  width: 100%;
  height: 10px;
  cursor: pointer;
  background: linear-gradient(to right, #9E54E3 var(--slider-value), #F3EAFD var(--slider-value));
  border-radius: 5px;
}

.income-slider::-webkit-slider-thumb {
  appearance: none;
  width: 10px;
  height: 15px;
  margin-top: -2.5px;
  border-radius: 50%;
  background: #9e54e3;
  cursor: pointer;
}

.income-slider::-moz-range-track {
  width: 100%;
  height: 8px;
  cursor: pointer;
  background: linear-gradient(
    to right,
    #9e54e3 0%,
    #9e54e3 var(--slider-value, 0%),
    #F3EAFD var(--slider-value, 0%),
    #F3EAFD 100%
  );
  border-radius: 5px;
}

.income-slider::-moz-range-thumb {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: #9e54e3;
  cursor: pointer;
}

.slider-labels {
  display: flex;
  margin-bottom: 100px;
  justify-content: space-between;
  font-family: Inter;
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  text-align: left;
}

.income-details p span,
.tax-amount {
  color: #9e54e3;
}

.calculate-button,
.optimize-button {
  width: 100%;
  padding: 16px;
  gap: 8px;
  border-radius: 8px;
  border: none;
  font-family: Sora;
  font-size: 16px;
  font-weight: 600;
  line-height: 20px;
  letter-spacing: 0.15px;
  transition: background-color 0.3s, color 0.3s;
}

.calculate-button {
  background: #f3eafd;
  color: #7e34bc;
}

.optimize-button {
  background: #9e54e3;
  color: #fff;
}

.optimize-button.disabled {
  background: #e0e0e0;
  color: #9e9e9e;
  cursor: not-allowed;
}

.after_button {
  margin-top: 10px;
}

.after_button p,
.detail-item span {
  font-family: Inter;
  font-size: 11px;
  font-weight: 400;
  line-height: 14px;
  text-align: left;
  color: #99a0ae;
}

.tax-amount {
  margin: 32px 0;
  padding: 20px;
  gap: 8px;
  border-radius: 6px;
  border: 1px solid #d8bcf6;
  background: #f3eafd;
  font-size: 48px;
  font-weight: 700;
  line-height: 60px;
  text-align: center;
}

.tax-details {
  justify-content: space-between;
  margin-bottom: 20px;
}

.detail-item {
  display: flex;
  justify-content: space-between;
  width: 100%;
  border-bottom: 1px solid #d8bcf6;
}

.detail-item span {
  color: #717784;
  font-size: 16px;
  font-weight: 400;
  margin: 10px 0;
  line-height: 26px;
  text-align: left;
}

.detail-value {
  color: #0e121b;
}

/* Responsive Styles */
@media (max-width: 768px) {
  .taxcal_main {
    flex-direction: column;
    width: 95%;
    padding: 16px;
  }
  .income-section h2 {
    font-family: Sora;
    font-size: 20px;
    font-weight: 600;
    line-height: 28px;
    text-align: left;
  }
  .income-section p {
    font-family: Inter;
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    text-align: left;
  }
  .income-input {
    font-family: Sora;
    font-size: 20px;
    font-weight: 400;
    line-height: 28px;
    letter-spacing: 0.15000000596046448px;
    text-align: left;
  }
  .slider-labels span {
    font-family: Inter;
    font-size: 12px;
    font-weight: 400;
    line-height: 16px;
    text-align: left;
  }
  .income-details p {
    font-family: Inter;
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    text-align: left;
  }

  .calculate-button {
    font-family: Sora;
    font-size: 16px;
    font-weight: 600;
    line-height: 20px;
    letter-spacing: 0.15000000596046448px;
  }
  .after_button {
    font-family: Inter;
    font-size: 11px;
    font-weight: 400;
    line-height: 14px;
    text-align: left;
  }
  .tax-section h2 {
    font-family: Sora;
    font-size: 18px;
    font-weight: 400;
    line-height: 26px;
    text-align: center;
  }
  .tax-amount {
    font-family: Sora;
    font-size: 28px;
    font-weight: 700;
    line-height: 38px;
    text-align: center;
  }
  .detail-item span {
    font-family: Inter;
    font-size: 14px;
    font-weight: 400;
    line-height: 24px;
    text-align: left;
  }
  .detail-item .detail-value {
    font-family: Inter;
    font-size: 14px;
    font-weight: 400;
    line-height: 24px;
    text-align: left;
    color: #0e121b;
  }
  .optimize-button {
    padding: 16px 16px 16px 16px;
    gap: 8px;
    border-radius: 8px;
    background: var(--Color-Tokens-Primary-Color-primary-base, #9e54e3);
    font-family: Sora;
    font-size: 16px;
    font-weight: 600;
    line-height: 20px;
    letter-spacing: 0.15000000596046448px;
  }

  .after_button p {
    font-family: Inter;

    font-size: 11px;
    font-weight: 400;
    line-height: 14px;
    text-align: left;
  }
  .taxcal_left,
  .taxcal_right {
    width: 100%;
  }

  .income-slider {
    height: 8px;
  }

  .income-slider::-webkit-slider-runnable-track,
  .income-slider::-moz-range-track {
    height: 8px;
  }

  .income-slider::-webkit-slider-thumb,
  .income-slider::-moz-range-thumb {
    height: 15px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Taxcal/taxcal.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,aAAa;EACb,UAAU;EACV,SAAS;EACT,mBAAmB;EACnB,yBAAyB;EACzB,8BAA8B;AAChC;;AAEA;;EAEE,UAAU;EACV,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;;EAEE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,YAAY;EAEZ,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,+FAA+F;EAC/F,kBAAkB;AACpB;;AAEA;EAEE,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,eAAe;EACf;;;;;;GAMC;EACD,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,oBAAoB;EACpB,8BAA8B;EAC9B,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;EAEE,WAAW;EACX,aAAa;EACb,QAAQ;EACR,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;EACtB,6CAA6C;AAC/C;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,QAAQ;EACR,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,WAAW;EACX,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA,sBAAsB;AACtB;EACE;IACE,sBAAsB;IACtB,UAAU;IACV,aAAa;EACf;EACA;IACE,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;EAClB;EACA;IACE,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;EAClB;EACA;IACE,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,qCAAqC;IACrC,gBAAgB;EAClB;EACA;IACE,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;EAClB;EACA;IACE,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,qCAAqC;EACvC;EACA;IACE,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;EAClB;EACA;IACE,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;EAClB;EACA;IACE,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;EAChB;EACA;IACE,4BAA4B;IAC5B,QAAQ;IACR,kBAAkB;IAClB,mEAAmE;IACnE,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,qCAAqC;EACvC;;EAEA;IACE,kBAAkB;;IAElB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;EAClB;EACA;;IAEE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;;IAEE,WAAW;EACb;;EAEA;;IAEE,YAAY;EACd;AACF","sourcesContent":[".taxcal {\n  align-items: center;\n  justify-content: center;\n  display: flex;\n}\n\n.taxcal_main {\n  padding: 32px;\n  display: flex;\n  width: 85%;\n  gap: 32px;\n  border-radius: 16px;\n  border: 1px solid #9e54e3;\n  justify-content: space-between;\n}\n\n.taxcal_left,\n.taxcal_right {\n  width: 49%;\n  padding: 16px;\n  gap: 8px;\n}\n\n.taxcal_right {\n  border-radius: 16px;\n  border: 1px solid #d8bcf6;\n  background-color: #faf6fe;\n}\n\n.income-section h2,\n.tax-section h2 {\n  font-family: Sora;\n  font-size: 24px;\n  font-weight: 600;\n  line-height: 32px;\n  text-align: left;\n  color: #0e121b;\n}\n\n.income-section p {\n  font-family: Inter;\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 24px;\n  text-align: left;\n  color: #99a0ae;\n}\n\n.income-input {\n  width: 100%;\n  padding: 8px;\n  color: #0e121b;\n  margin-bottom: 10px;\n  border: 1px solid #cacfd8;\n  border-radius: 6px;\n  font-family: Sora;\n  font-size: 20px;\n  font-weight: 400;\n  line-height: 28px;\n  letter-spacing: 0.15px;\n  text-align: left;\n}\n\n.income-slider {\n  -webkit-appearance: none;\n  width: 100%;\n  height: 8px;\n  border-radius: 5px;\n  background: #faf6fe;\n  outline: none;\n  opacity: 0.7;\n  -webkit-transition: 0.2s;\n  transition: opacity 0.2s;\n  margin-bottom: 10px;\n}\n\n.income-slider::-webkit-slider-runnable-track {\n  width: 100%;\n  height: 10px;\n  cursor: pointer;\n  background: linear-gradient(to right, #9E54E3 var(--slider-value), #F3EAFD var(--slider-value));\n  border-radius: 5px;\n}\n\n.income-slider::-webkit-slider-thumb {\n  -webkit-appearance: none;\n  appearance: none;\n  width: 10px;\n  height: 15px;\n  margin-top: -2.5px;\n  border-radius: 50%;\n  background: #9e54e3;\n  cursor: pointer;\n}\n\n.income-slider::-moz-range-track {\n  width: 100%;\n  height: 8px;\n  cursor: pointer;\n  background: linear-gradient(\n    to right,\n    #9e54e3 0%,\n    #9e54e3 var(--slider-value, 0%),\n    #F3EAFD var(--slider-value, 0%),\n    #F3EAFD 100%\n  );\n  border-radius: 5px;\n}\n\n.income-slider::-moz-range-thumb {\n  width: 20px;\n  height: 20px;\n  border-radius: 50%;\n  background: #9e54e3;\n  cursor: pointer;\n}\n\n.slider-labels {\n  display: flex;\n  margin-bottom: 100px;\n  justify-content: space-between;\n  font-family: Inter;\n  font-size: 12px;\n  font-weight: 400;\n  line-height: 16px;\n  text-align: left;\n}\n\n.income-details p span,\n.tax-amount {\n  color: #9e54e3;\n}\n\n.calculate-button,\n.optimize-button {\n  width: 100%;\n  padding: 16px;\n  gap: 8px;\n  border-radius: 8px;\n  border: none;\n  font-family: Sora;\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 20px;\n  letter-spacing: 0.15px;\n  transition: background-color 0.3s, color 0.3s;\n}\n\n.calculate-button {\n  background: #f3eafd;\n  color: #7e34bc;\n}\n\n.optimize-button {\n  background: #9e54e3;\n  color: #fff;\n}\n\n.optimize-button.disabled {\n  background: #e0e0e0;\n  color: #9e9e9e;\n  cursor: not-allowed;\n}\n\n.after_button {\n  margin-top: 10px;\n}\n\n.after_button p,\n.detail-item span {\n  font-family: Inter;\n  font-size: 11px;\n  font-weight: 400;\n  line-height: 14px;\n  text-align: left;\n  color: #99a0ae;\n}\n\n.tax-amount {\n  margin: 32px 0;\n  padding: 20px;\n  gap: 8px;\n  border-radius: 6px;\n  border: 1px solid #d8bcf6;\n  background: #f3eafd;\n  font-size: 48px;\n  font-weight: 700;\n  line-height: 60px;\n  text-align: center;\n}\n\n.tax-details {\n  justify-content: space-between;\n  margin-bottom: 20px;\n}\n\n.detail-item {\n  display: flex;\n  justify-content: space-between;\n  width: 100%;\n  border-bottom: 1px solid #d8bcf6;\n}\n\n.detail-item span {\n  color: #717784;\n  font-size: 16px;\n  font-weight: 400;\n  margin: 10px 0;\n  line-height: 26px;\n  text-align: left;\n}\n\n.detail-value {\n  color: #0e121b;\n}\n\n/* Responsive Styles */\n@media (max-width: 768px) {\n  .taxcal_main {\n    flex-direction: column;\n    width: 95%;\n    padding: 16px;\n  }\n  .income-section h2 {\n    font-family: Sora;\n    font-size: 20px;\n    font-weight: 600;\n    line-height: 28px;\n    text-align: left;\n  }\n  .income-section p {\n    font-family: Inter;\n    font-size: 14px;\n    font-weight: 400;\n    line-height: 20px;\n    text-align: left;\n  }\n  .income-input {\n    font-family: Sora;\n    font-size: 20px;\n    font-weight: 400;\n    line-height: 28px;\n    letter-spacing: 0.15000000596046448px;\n    text-align: left;\n  }\n  .slider-labels span {\n    font-family: Inter;\n    font-size: 12px;\n    font-weight: 400;\n    line-height: 16px;\n    text-align: left;\n  }\n  .income-details p {\n    font-family: Inter;\n    font-size: 14px;\n    font-weight: 400;\n    line-height: 20px;\n    text-align: left;\n  }\n\n  .calculate-button {\n    font-family: Sora;\n    font-size: 16px;\n    font-weight: 600;\n    line-height: 20px;\n    letter-spacing: 0.15000000596046448px;\n  }\n  .after_button {\n    font-family: Inter;\n    font-size: 11px;\n    font-weight: 400;\n    line-height: 14px;\n    text-align: left;\n  }\n  .tax-section h2 {\n    font-family: Sora;\n    font-size: 18px;\n    font-weight: 400;\n    line-height: 26px;\n    text-align: center;\n  }\n  .tax-amount {\n    font-family: Sora;\n    font-size: 28px;\n    font-weight: 700;\n    line-height: 38px;\n    text-align: center;\n  }\n  .detail-item span {\n    font-family: Inter;\n    font-size: 14px;\n    font-weight: 400;\n    line-height: 24px;\n    text-align: left;\n  }\n  .detail-item .detail-value {\n    font-family: Inter;\n    font-size: 14px;\n    font-weight: 400;\n    line-height: 24px;\n    text-align: left;\n    color: #0e121b;\n  }\n  .optimize-button {\n    padding: 16px 16px 16px 16px;\n    gap: 8px;\n    border-radius: 8px;\n    background: var(--Color-Tokens-Primary-Color-primary-base, #9e54e3);\n    font-family: Sora;\n    font-size: 16px;\n    font-weight: 600;\n    line-height: 20px;\n    letter-spacing: 0.15000000596046448px;\n  }\n\n  .after_button p {\n    font-family: Inter;\n\n    font-size: 11px;\n    font-weight: 400;\n    line-height: 14px;\n    text-align: left;\n  }\n  .taxcal_left,\n  .taxcal_right {\n    width: 100%;\n  }\n\n  .income-slider {\n    height: 8px;\n  }\n\n  .income-slider::-webkit-slider-runnable-track,\n  .income-slider::-moz-range-track {\n    height: 8px;\n  }\n\n  .income-slider::-webkit-slider-thumb,\n  .income-slider::-moz-range-thumb {\n    height: 15px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
